module.exports = ".dashboard-item {\r\n    background: #f9f9f9;\r\n    padding: 20px;\r\n    margin-bottom: 30px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.css
// module id = ./src/app/dashboard/dashboard.component.css
// module chunks = main